import * as React from 'react'
import { SeriesTemplate, CommonSeriesSettings, Legend, Series } from 'devextreme-react/chart'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { PlatformContext } from '../../../../components/context/platform'
import { sp } from '../../../../utils/platformSelect'

export const StreamChart: React.FunctionComponent<{ albumIds: string[] }> = ({ albumIds, ...props }) => {
    const platform = React.useContext(PlatformContext)
    return (
        <BPMChart {...props} title='Streams' subTitle={sp(platform, { default: 'By Version', create: undefined })} type='bar' key={albumIds.join()}
            additionalParams={{ albumIds }}
            onRequestLoad={(options, signal) => {
                options.query = JSON.stringify([[sp(platform, { default: 'album_id', create: 'sound_package_id' }), 'IN', options.albumIds]]);
                (options as any).albumIds = undefined
                return BPMAnalyticsAPI.post<any>('compare/streams', options)
            }}>
            {platform != 'create' && <SeriesTemplate
                nameField={'tag_name'}
            />}
            {platform == 'create' && <Series
                name={'Downloads'}
            />}
            <CommonSeriesSettings type='bar'
                valueField="count"
                argumentField="name">
            </CommonSeriesSettings>
            <Legend visible />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Compare/charts/StreamChart.tsx